export const bulkActionsEntryStatus = {
  generating_template: 'Gerando template',
  awaiting_file: 'Aguardando arquivo',
  with_failure: 'Com falha',
  processing: 'Processando',
  awaiting_confirmation: 'Aguardando confirmação',
  completing: 'Finalizando processo',
  completed: 'Finalizado',
}
